const React = require('react');
const noop = require('mn-utils/noop');
const FormSubmitBtn = require('../FormSubmitBtn');
const FormAdditionalBtn = require('../FormAdditionalBtn');

module.exports = ({className, submitBtnData = {}, additionalBtnsList = [], additionalNodesList = []}) => {

  const {
    formCtx,
    changesCheckDisabled,
    disabled: submitBtnDisabled,
    text: submitBtnText,
    onClick: submitBtnOnClick,
    testId
  } = submitBtnData;

  return (
    <div
      className={
        `layoutRow fxwWrap mh-27 mh-20@m2`
        + (className ? ` ${className}` : '')
      }
    >
      <div className="mt25 ph27 ph20@m2">
        <FormSubmitBtn
          formCtx={formCtx}
          disabled={submitBtnDisabled}
          onClick={submitBtnOnClick}
          changesCheckDisabled={changesCheckDisabled}
          testId={testId}
        >
          {submitBtnText}
        </FormSubmitBtn>
      </div>
      {additionalBtnsList.map(({text, onClick = noop, testId, disabled}, id) => (
        <div key={id} className="mt25 ph27 ph20@m2">
          <FormAdditionalBtn onClick={onClick} disabled={disabled} testId={testId}>
            {text}
          </FormAdditionalBtn>
        </div>
      ))}
      {additionalNodesList.map((item, index) => (
        <div key={index} className="ph27 ph20@m2">
          {item}
        </div>
      ))}
    </div>
  )
}
